<div class="proposal-card" [class.pointer]="canEdit" (click)="onEditClicked()" *ngIf="proposal">
  <div class="grid no-padding">
    <div class="row">
      <div class="col no-padding" size="12">
        <div class="row title-row">
          <div class="col no-padding" size="1">
            <img class="proposal-card__img" [src]="proposal.img" />
          </div>
          <div class="col no-padding" size="10">
            <span class="proposal-card__info__title">{{ proposal.title | translate }}</span>
          </div>
          <div class="col no-padding" size="1">
            <img
              class="proposal-card__actions"
              src="assets/imgs/icons/pencil-green.svg"
              *ngIf="canEdit && hasProposalsFullfilled" />
          </div>
        </div>

        <ng-container *ngIf="hasProposalsFullfilled; else noProposals">
          <div class="proposals" *ngFor="let orderedProposal of proposal.proposalsByOrder; trackBy: trackByItems">
            <p class="proposals__title" *ngIf="showEmptyProposals || orderedProposal.proposals.length">
              {{ 'MANAGE_VACATIONS.PROPOSAL' | translate }} {{ orderedProposal.order }}
            </p>
            <p class="proposals__date" *ngFor="let item of orderedProposal.proposals; trackBy: trackByItems">
              {{ item.description }}
            </p>
            <p class="proposals__date" *ngIf="showEmptyProposals && !orderedProposal.proposals.length">
              {{ 'MANAGE_VACATIONS.NO_PREFERENCES' | translate }}
            </p>
          </div>
        </ng-container>

        <ng-template #noProposals>
          <ng-container *ngIf="canEdit; else list">
            <div class="empty-proposals">
              <p>{{ 'MANAGE_VACATIONS.STILL_EMPTY_PROPOSALS' | translate }}</p>
              <button class="c-button primary" (click)="onAddProposalsClicked()" *ngIf="canEdit">
                {{ 'MANAGE_VACATIONS.ADD_PROPOSALS' | translate }}
              </button>
            </div>
          </ng-container>

          <ng-template #list>
            <div class="proposals" *ngFor="let number of maxProposals; trackBy: trackByItems">
              <p class="proposals__title">{{ 'MANAGE_VACATIONS.PROPOSAL' | translate }} {{ number }}</p>
              <p class="proposals__date">{{ 'MANAGE_VACATIONS.NO_PREFERENCES' | translate }}</p>
            </div>
          </ng-template>
        </ng-template>
      </div>
    </div>
  </div>
</div>
